import {
  EActionType,
  IDailyRentOfferForMobileSite,
} from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { IOfferForMobileSiteSchema } from '../../repositories/search-engine/entities/offer/OfferForMobileSiteSchema';

/**
 * Адаптер оффера рекомендаций (search-engine) к типу горизонтальной карточки.
 *
 * search-engine не отдаёт обязательные посуточные поля — подставляем заглушки.
 * Заглушки безопасны только потому, что карточка рекомендаций рендерится
 * с variant="recommendation": кнопки действий, рейтинг и избранное скрыты,
 * isHotel-ветки не используются.
 *
 * price.period проходит как есть: enum'ы обоих репозиториев сгенерированы
 * идентично; новое значение периода у бэка даст цену без суффикса.
 */
export function prepareEmptyListingSuggestionOffer(offer: IOfferForMobileSiteSchema): IDailyRentOfferForMobileSite {
  return {
    ...offer,
    actionType: EActionType.Contact,
    isHotel: false,
    isOnlineBooking: false,
    showBookingCalendar: false,
  };
}
